import HB1416Tracker from './HB1416Tracker.container';

export default HB1416Tracker;
